module.exports = __webpack_public_path__ + "img/main-top-header1.5b739fd6.png";